export const LOGOS = [
  { id: 'primary', title: 'Primary logo', note: 'Full colour, for white or light backgrounds.', bg: '#FFFFFF',
    png: 'audinexa-logo-primary.png', svg: 'audinexa-logo-primary.svg', embedded: 'audinexa-logo-primary-embedded.svg' },
  { id: 'reversed', title: 'Reversed logo', note: 'All white, for the navy brand background or dark photos.', bg: '#0F1D3A',
    png: 'audinexa-logo-reversed.png', svg: 'audinexa-logo-reversed.svg', embedded: 'audinexa-logo-reversed-embedded.svg',
    extra: 'audinexa-logo-reversed-transparent.png' },
  { id: 'icon', title: 'Icon', note: 'Symbol only, for app icons, favicons and social avatars.', bg: '#FFFFFF', square: true,
    png: 'audinexa-icon.png', svg: 'audinexa-icon.svg', embedded: 'audinexa-icon-embedded.svg' },
];

export const PALETTE = [
  { group: 'Primary', note: 'Taken from the logo.', colours: [
    { name: 'AudiNexa Red', hex: '#E24B4A', use: 'Logo ring, highlights' },
    { name: 'AudiNexa Blue', hex: '#378ADD', use: 'Logo X, links, key actions' },
  ] },
  { group: 'Secondary', note: 'Text and surfaces.', colours: [
    { name: 'Midnight Navy', hex: '#0F1D3A', use: 'Brand background, sidebar, primary buttons' },
    { name: 'Ink', hex: '#1C1C1A', use: 'Wordmark, headings' },
    { name: 'Slate Grey', hex: '#5F5E5A', use: 'Tagline, secondary text' },
    { name: 'Mist', hex: '#EEF1FA', use: 'App background' },
  ] },
  { group: 'Accent', note: 'Used sparingly in the app.', colours: [
    { name: 'Signal Teal', hex: '#22D3EE', use: 'Accents on dark surfaces' },
    { name: 'Deep Teal', hex: '#0891B2', use: 'Interactive text on light surfaces' },
    { name: 'Mint', hex: '#37D399', use: 'Success, positive KPIs' },
    { name: 'Lavender', hex: '#7B68EE', use: 'Charts, KPI cards' },
  ] },
];

export const FONTS = [
  { family: 'Inter', role: 'Primary typeface — used across the whole app', css: '"Inter", system-ui, sans-serif',
    source: 'Google Fonts (free, open licence)', weights: [
      { w: 800, label: 'Extra Bold 800', use: 'Display headings' },
      { w: 700, label: 'Bold 700', use: 'Headings' },
      { w: 600, label: 'Semi Bold 600', use: 'Sub-headings, buttons' },
      { w: 400, label: 'Regular 400', use: 'Body text' },
      { w: 500, label: 'Medium 500', use: 'Captions, labels', small: true },
    ] },
  { family: 'Cabinet Grotesk', role: 'Display typeface — marketing headings', css: '"Cabinet Grotesk", "Inter", sans-serif',
    source: 'Fontshare (free for commercial use)', weights: [
      { w: 800, label: 'Extra Bold 800', use: 'Hero headings' },
      { w: 700, label: 'Bold 700', use: 'Section headings' },
    ] },
  { family: 'Manrope', role: 'Marketing body typeface', css: '"Manrope", "Inter", sans-serif',
    source: 'Google Fonts (free, open licence)', weights: [
      { w: 600, label: 'Semi Bold 600', use: 'Lead paragraphs' },
      { w: 400, label: 'Regular 400', use: 'Body text' },
      { w: 500, label: 'Medium 500', use: 'Captions', small: true },
    ] },
];

export const VOICE = ['Confident.', 'Clinical.', 'Caring.'];
export const SAMPLE = 'The future of audiology is here.';

export const hexToRgb = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

export const rgbToCmyk = ([r, g, b]) => {
  const [rr, gg, bb] = [r / 255, g / 255, b / 255];
  const k = 1 - Math.max(rr, gg, bb);
  if (k >= 1) return [0, 0, 0, 100];
  const c = (x) => Math.round(((1 - x - k) / (1 - k)) * 100);
  return [c(rr), c(gg), c(bb), Math.round(k * 100)];
};
